export default function FlightTravellers(
    $compile,
    $timeout,
    $templateRequest,
    flightsUtils,
    l10nService
) {
    'ngInject';

                return {
                    restrict: 'AE',
                    scope: {
                        options: '=options',
                        params: '=params',
                        templateUrl: '@templateUrl',
                    },
                    link: function(scope, element) {
                        scope.l10n = l10nService;
                        scope.opened = false;
                        Object.defineProperty(scope, 'totalAdults', {
                            get: function() {
                                const isAdultObject = angular.isObject(this.params.Travelers.Adult) && this.params.Travelers.Adult !== null;
                                const adults = isAdultObject ? this.params.Travelers.Adult : angular.fromJson(this.params.Travelers.Adult);
                                let value = +adults.value;
                                if (value === 1) {
                                    value = +adults.value + ' ' + l10nService.localize('Adult');
                                } else {
                                    value = +adults.value + ' ' + l10nService.localize('travellers');
                                }
                                return value;
                            },
                            set: function() {
                            },
                        });
                        Object.defineProperty(
                            scope, 'totalChildren', {
                                /*eslint complexity: ["error", 10]*/
                                get: function() {
                                    const isInfantObj = angular.isObject(this.params.Travelers.Infant) && this.params.Travelers.Infant !== null;
                                    const isChildObject = angular.isObject(this.params.Travelers.Child) && this.params.Travelers.Child !== null;
                                    const infant = isInfantObj ? this.params.Travelers.Infant : angular.fromJson(this.params.Travelers.Infant);
                                    const child = isChildObject ? this.params.Travelers.Child : angular.fromJson(this.params.Travelers.Child);
                                    const infants = +infant.value;
                                    const children = +child.value;
                                    let result = '';

                                    if (children === 1) {
                                        result += l10nService.localize('1 child ');
                                    } else if (children > 1) {
                                        result += children + l10nService.localize(' children ');
                                    }

                                    if (children && infants) {
                                        result += ' + ';
                                    }

                                    if (infants === 1) {
                                        result += l10nService.localize('1 infant');
                                    } else if (infants > 1) {
                                        result += infants + l10nService.localize(' infants');
                                    }

                                    if ((children + infants) === 0) {
                                        result += '0 ' + l10nService.localize('children');
                                    }
                                    return result;
                                },
                                set: function() {
                                },
                            }
                        );

                        /**
                         * If number of adults changes manually change children and infants options and reset selection to 0
                         */
                        scope.onAdultsChange = function(value) {
                            const adults = +value;
                            const params = scope.params;
                            const infants = +params.Travelers.Infant.value;
                            const children = +params.Travelers.Child.value;

                            scope.options.infants = flightsUtils.makeTravellersOptions(l10nService.localize('Infant'), adults, true);
                            scope.options.children = flightsUtils.makeTravellersOptions(l10nService.localize('Child'), 4 - adults, true);

                            if ((children + adults) > 4 || adults < infants) {
                                params.Travelers.Infant = angular.copy(scope.options.infants[0]);
                                params.Travelers.Child = angular.copy(scope.options.children[0]);
                            }
                        };
                        scope.addTraveller = function(type) {
                            const params = scope.params;
                            const adults = +params.Travelers.Adult.value;
                            const infants = +params.Travelers.Infant.value;
                            const children = +params.Travelers.Child.value;
                            const kids = children;
                            const totalTravellers = adults + kids;
                            if (type === 'adult') {
                                if (totalTravellers < 4 && scope.options.adults.length > 1) {
                                    params.Travelers.Adult.value = (parseInt(params.Travelers.Adult.value) + 1);
                                }
                            } else if (type === 'infant') {
                                if (infants < adults && scope.options.isChildrenAllowed) {
                                    params.Travelers.Infant.value = (parseInt(params.Travelers.Infant.value) + 1);
                                }
                            } else if (type === 'child') {
                                if (totalTravellers < 4 && kids < 2 && scope.options.isChildrenAllowed) {
                                    params.Travelers.Child.value = (parseInt(params.Travelers.Child.value) + 1);
                                }
                            }
                        };
                        scope.openDropdown = function(obj) {
                            const item = obj.currentTarget.attributes.controls.nodeValue;
                            const dropdown = angular.element('#' + item);
                            dropdown.toggleClass('active');
                            obj.currentTarget.classList.add('active');
                            if (dropdown.hasClass('active')) {
                                scope.opened = true;
                            } else {
                                obj.currentTarget.classList.remove('active');
                                scope.opened = false;
                            }
                        };
                        scope.clickOutside = function(event) {
                            const dropdown = angular.element(event[1]);
                            const btn = angular.element(event[0]);
                                if (dropdown.hasClass('active') && scope.opened) {
                                    dropdown.removeClass('active');
                                    btn.removeClass('active');
                                    scope.opened = false;
                                }
                        };
                        scope.controlInput = function(event) {
                            const charCode = (event.which) ? event.which : event.keyCode;
                            if (charCode === 39) {
                               const add = event.currentTarget.children[2];
                                $timeout(function() {
                                    add.click();
                                }, 100);
                            }
                            if (charCode === 37) {
                                const remove = event.currentTarget.children[0];
                                $timeout(function() {
                                    remove.click();
                                }, 100);
                            }
                        };
                        scope.removeTraveller = function(type) {
                            const params = scope.params;
                            if (type === 'adult') {
                                if ((parseInt(params.Travelers.Adult.value) > 1)) {
                                    params.Travelers.Adult.value = (parseInt(params.Travelers.Adult.value) - 1);
                                    if ((parseInt(params.Travelers.Infant.value) > params.Travelers.Adult.value)) {
                                        params.Travelers.Infant.value = (parseInt(params.Travelers.Infant.value) - 1);
                                    }
                                }
                            } else if (type === 'infant') {
                                if ((parseInt(params.Travelers.Infant.value) + parseInt(params.Travelers.Child.value) > -1)) {
                                    params.Travelers.Infant.value = (parseInt(params.Travelers.Infant.value) - 1);
                                } else {
                                   // alert('Too many kids');
                                }
                            } else if (type === 'child') {
                                if ((parseInt(params.Travelers.Child.value) + parseInt(params.Travelers.Infant.value) > -1)) {
                                    params.Travelers.Child.value = (parseInt(params.Travelers.Child.value) - 1);
                                } else {
                                    //alert('Too many kids dude');
                                }
                            }
                        };
                        scope.getType = function(type) {
                            const params = scope.params;
                            switch (type) {
                                case 'adult':
                                    // code block
                                    return params.Travelers.Adult.value;
                                case 'infant':
                                     return params.Travelers.Infant.value;
                                case 'child':
                                    return params.Travelers.Child.value;
                                default:
                                // code block
                            }
                        };

                        scope.disable = function(value, type) {
                            const typo = scope.getType(type);
                            if ((parseInt(typo) === value)) {
                                return true;
                            }
                            return false;
                        };

                        /**
                         * Render directive with provided templateUrl
                         */
                        $templateRequest(scope.templateUrl).then(function(html) {
                          element.html(html).show();
                          $compile(element.contents())(scope);
                        });
                    },
                };
}



// WEBPACK FOOTER //
// ./src/app/modules/base/directives/ktFlightTravellers.directive.js